<template lang="pug">
.search
  v-overlay(:value="loading")
    v-progress-circular(indeterminate, size="64")
  v-row
    v-col(cols="12", md="10", offset-md="1")
      ViewPet(
        v-if="!loading && pet",
        :pet="pet",
        :owner="owner",
        :detail="true",
        :button_contact="true"
      )
</template>

<script>
import PetAPI from "@/api/pet";
import ViewPet from "@/components/pets/ViewPet.vue";

export default {
  name: "SearchPet",
  components: {
    ViewPet
  },
  beforeCreate() {
    this.$router.replace(
      `/search_pet/?code=${
        this.$route.query.code.match(/\s/g) &&
        !this.$route.query.code.startsWith(" ")
          ? this.$route.query.code.replace(/\s/g, "+")
          : this.$route.query.code
      }`
    );
  },
  async created() {
    this.loading = true;
    const response = await PetAPI.searchPet(
      this.$route.query.code.replace(/\s/g, "+")
    );
    this.loading = false;
    if (response.status) {
      this.pet = response.data.pet;
      this.owner = response.data.owner;
    } else {
      this.$swal({
        icon: "error",
        title: response.data
      });
    }
  },
  data() {
    return {
      pet: null,
      owner: null,
      loading: true
    };
  }
};
</script>
